import React from "react"
import type { NoteCardViewModel } from "../types"
import NoteCard from "./NoteCard"
import "./NotesGrid.style.scss"

interface NotesGridProps {
  cards: NoteCardViewModel[]
  loading: boolean
  loadingMore: boolean
  hasMore: boolean
  remaining: number
  removingId: string | null
  editingId: string | null
  onLoadMore: () => void
  onEdit: (card: NoteCardViewModel) => void
  onRemove: (card: NoteCardViewModel) => void
  onOpen: (card: NoteCardViewModel) => void
}

const NotesGrid = ({
  cards,
  loading,
  loadingMore,
  hasMore,
  remaining,
  removingId,
  editingId,
  onLoadMore,
  onEdit,
  onRemove,
  onOpen,
}: NotesGridProps) => (
  <div className="notes-grid">
    <div className={`notes-grid__cards ${loading ? "is-fetching" : ""}`}>
      {cards.map((card) => (
        <NoteCard
          key={card.id}
          card={card}
          removing={removingId === card.id}
          editing={editingId === card.id}
          onEdit={() => onEdit(card)}
          onRemove={() => onRemove(card)}
          onOpen={() => onOpen(card)}
        />
      ))}
    </div>
    {hasMore ? (
      <div className="notes-grid__more">
        <button
          type="button"
          disabled={loading || loadingMore}
          onClick={onLoadMore}
        >
          {loadingMore ? "Loading…" : "Load more"}
        </button>
        {remaining > 0 ? (
          <span>
            {remaining} more note{remaining === 1 ? "" : "s"}
          </span>
        ) : null}
      </div>
    ) : null}
  </div>
)

export default NotesGrid
